import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { MaterialObjectSelection, MaterialRadioGroupControl, } from 'console/shared/components/fields';
import { useEditingProps } from '../../utils/unpack-props';
import { HeatingCircuit } from 'z3k-config';
import { useBox } from 'shared/hooks/utils';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card/full-row';
import { selectAnalogInputsOptions } from 'z3k-parser/lib/z3k-selectors';
import { HeatingCircuitContext } from '../context/type';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { ControlWithoutValidation } from 'console/shared/components/fields/control/without-validation';
export const ExtThermostat = memo(function ExtThermostatImpl() {
    const { item, id, z3k_name, withBoilerAdapter, onChange } = useContext(HeatingCircuitContext);
    const { config } = useContext(Z3KSettingsEditor);
    const analogInputs = selectAnalogInputsOptions(config);
    const hcBox = useBox(item);
    const { device_spec, service_view } = useContext(Z3KSettings);
    const externalThermostatEditingProps = useEditingProps(id, z3k_name, 'external_thermostat');
    const onChangeExternalThermostat = useCallback((thermostat_id) => {
        onChange(HeatingCircuit.changeExtThermostat(hcBox.current, thermostat_id));
    }, [onChange]);
    const is_lock_mode = useMemo(() => HeatingCircuit.isExtThermostatLockMode(item), [item.setting_register]);
    const lock_mode_state = useMemo(() => (is_lock_mode ? '1' : '0'), [is_lock_mode]);
    const external_thermostat_options = useMemo(() => [
        {
            label: 'Запросом тепла',
            value: '0',
            help_id: null,
        },
        {
            label: 'Активностью контура',
            value: '1',
            help_id: null,
        },
    ], []);
    const radio_field = useCallback((input_props) => (_jsx(MaterialRadioGroupControl, { control_values: external_thermostat_options, ...input_props })), [external_thermostat_options]);
    const onChangeLockModeState = useCallback((checked) => {
        onChange(HeatingCircuit.setExtThermostatLockMode(hcBox.current, checked == '1'));
    }, [onChange]);
    if (!service_view) {
        return null;
    }
    if (device_spec.heating.has_heating &&
        !device_spec.heating.has_external_thermostat) {
        return null;
    }
    if (withBoilerAdapter) {
        return null;
    }
    return (_jsxs(SettingFullRow, { children: [_jsx(MaterialObjectSelection, { label: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E \u0442\u0435\u0440\u043C\u043E\u0441\u0442\u0430\u0442\u0430", help_id: "heating_circuits_external_thermostat", options: analogInputs, ...externalThermostatEditingProps, onChange: onChangeExternalThermostat }), !HeatingCircuit.isCooling(item) && item.external_thermostat !== null && (_jsx(ControlWithoutValidation, { label: "\u0421\u0438\u0433\u043D\u0430\u043B \u0442\u0435\u0440\u043C\u043E\u0441\u0442\u0430\u0442\u0430 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442", value: lock_mode_state, onChange: onChangeLockModeState, field: radio_field }))] }));
});
